module.exports = __webpack_public_path__ + "img/Kehinde Oseni_Co-founder.77d5afff.jpg";